import { config } from '@/pageConfig/legalStuff/fr/en';
import { LegalStuffPageTemplate } from '@/pageTemplate/LegalStuffPageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function LegalStuffPage() {
  const { trackEvent } = useAnalyticsContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: we just one it on load so no need to add it as a dependency
  useEffect(() => {
    trackEvent('legal_stuff_page.viewed');
  }, []);

  return <LegalStuffPageTemplate config={config} />;
}
